module.exports = __webpack_public_path__ + "img/bg_02.3064dce5.jpg";